import { Decimal, sumWithDecimal } from "@syla/shared/decimal";
import { AssetDetail } from "@syla/shared/types/responses/GetAccountAssetsResponse";
import { Ledger } from "@syla/shared/types/responses/TransactionEvent";
import { groupBy, map } from "lodash";

export interface BalanceDetail {
  asset: AssetDetail;
  amount: Decimal;
  balance?: Decimal;
  walletBalance?: Decimal;
}

export const getBalanceDetailsFromLedgers = (
  ledgers: Ledger[],
): BalanceDetail[] => {
  const groupedLedgers = groupBy(ledgers, (to) => to.asset._id);

  // Loop over each asset
  return map(groupedLedgers, (assetLedgers) => ({
    asset: assetLedgers[0].asset,
    amount: sumWithDecimal(assetLedgers, "amount"),
    ...assetLedgers.at(-1)?.balances,
  }));
};
